import t from"./regex.js";function e(e){return"string"==typeof e&&t.test(e)}export{e as default};
